<card-layout title="Your Accident - Accident Description" icon="car_crash">
    <div class="header-text-wrapper">
        <p class="header-text">
            Follow our guide  to understand more about describing the accident and choosing the relevant summary.
        </p>
    </div>
    <div [ngModelGroup]="_formNames.YourAccidentDescription" #formGroup="ngModelGroup" class="overlay-container">        
        <minster-text-area label="Accident Description" [name]="_fcn.AccDescription.Description" [(ngModel)]="_accident.accidentDescription" [maxLength]="500" [required]="true" [showInfo]="true" [disabled]="_readonly" />
        <minster-select label="Accident Summary" [name]="_fcn.AccDescription.Summary" [(ngModel)]="_accident.summaryId" [lookUp]="_accidentSummary" [required]="true" [showInfo]="isSelectedOption"  [_toolTip]="_toolTip" [disabled]="_readonly" />
         
        <minster-select label="Your Estimated Speed" [name]="_fcn.AccDescription.EstimatedSpeed" [(ngModel)]="_accident.claimantVehicleSpeedId" [lookUp]="_vehicleSpeed" [startsAtZero]="true" [required]="true" [showInfo]="true" [disabled]="_readonly" />
        <minster-checkbox label="Do you have any CCTV or Dashcam footage?" [name]="_fcn.AccDescription.CctvOrDashcam" [(ngModel)]="_accident.hasAccidentCctv" [required]="true" [disabled]="_readonly" />
        <minster-checkbox label="Do you have any photos of evidence of damage to vehicle?" [name]="_fcn.AccDescription.HasAccidentPhoto" [(ngModel)]="_accident.hasAccidentPhoto" [required]="true" [disabled]="_readonly" />
    </div>
</card-layout>

<div class="back-next">
    <button mat-raised-button type="button" class="secondary-button" (click)="onPrevious()">Back</button>
    <button mat-raised-button type="button"  color="accent" (click)="onNext()">Next</button>
</div>

